import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { languages } from 'services/constants';
import { getPortfolios } from './pacingPlanActions';
import { reportException } from 'services/logging';

export const grabPortfolios = createAsyncThunk(
  'GET_PORTFOLIOS',
  async (requestObject) => {
    try {
      const data = await getPortfolios(requestObject);
      return { data: data.data, status: data.status };
    } catch (error) {
      reportException(error, 'grab portfolios');
      return error.response;
    }
  }
);

const initialState = {
  portfolioData: [],
};

const portfolioSlice = createSlice({
  name: 'fundData',
  initialState,
  reducers: {
    setPortfolioData: (state, action) => {
      state.portfolioData = action.payload;
    },
  },
});

export const { setPortfolioData } = portfolioSlice.actions;

export default portfolioSlice.reducer;
